import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import MarketplaceUsersTable from '../../../MarketplaceHub/MarketplaceUsersTable';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { getLocalStorageItem } from '../../../../utils/helper';
import { fetchCompanyMarketplaceUsers } from './companyMarketplaceApi';

/**
 * Company Marketplace → Employees/Members list.
 * Every user of the current population appears (never-redeemed ones with
 * dashes, sorted last); a row opens their redemption profile.
 */
const CMarketplaceUsers = () => {
  const navigate = useNavigate();
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  const fetcher = useCallback(
    (params) => fetchCompanyMarketplaceUsers({ ...params, department }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Marketplace — {isB2BFansMode ? 'Members' : 'Employees'} | Shoorah</title>
      </Helmet>

      <p className="text-sm text-gray-500 dark:text-gray-400 mb-3">
        Your {isB2BFansMode ? 'members' : 'employees'} and what they have redeemed from the
        marketplace. Open a user to see their full redemption profile.
      </p>

      <MarketplaceUsersTable
        fetcher={fetcher}
        showCompanyColumn={false}
        onOpenUser={(rowData) =>
          navigate(`/${slug}/marketplace/insights/user?userId=${rowData?._id}`)
        }
        tableName="company_marketplace_users"
      />
    </div>
  );
};

export default CMarketplaceUsers;
